export default "__VITE_ASSET__Cmjy5zWk__"